import { pluralize } from './pluralize'

export enum Format {
  Colon = 'Colon',
  Short = 'Short',
  Full = 'Full',
}

export const convertSecondsToHHMM = (seconds: number, format: Format = Format.Colon): string => {
  const hours = Math.floor(seconds / 3600)
  const remainingMinutes = Math.round((seconds % 3600) / 60)

  const formattedHours = hours.toString().padStart(2, '0').slice(0, 2)
  const formattedMinutes = hours > 0 ? remainingMinutes.toString().padStart(2, '0') : remainingMinutes.toString()

  if (format === Format.Full) {
    const formattedHours = hours > 0 ? `${hours} ${pluralize(hours, 'hour')}` : ''
    const formattedMinutes =
      remainingMinutes > 0 || hours === 0 ? `${remainingMinutes} ${pluralize(remainingMinutes, 'minute')}` : ''

    return `${formattedHours} ${formattedMinutes}`
  }

  if (format === Format.Short) {
    if (hours === 0) {
      return `${formattedMinutes}min`
    }

    return `${formattedHours}h ${formattedMinutes}min`
  }

  return `${formattedHours}:${formattedMinutes}`
}
